import { getApi } from '../api/storeFront';
import { parseStoreProduct } from '../utils';
const getProductsByCategory = async ({ sectionName, count }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('section', sectionName);
    urlParams.append('count', count.toString());
    const response = await getApi(`/products?${urlParams.toString()}`, logger);
    const products = response?.data;
    return {
        data: [...parseStoreProduct(products)],
    };
};
export default getProductsByCategory;
